var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1784_14238)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1784_14238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.654 121.628V131.039C107.654 134.763 104.636 137.783 100.91 137.783H37.4107C33.6879 137.783 30.6666 134.765 30.6666 131.039V125.215H46.6058C47.2279 128.662 47.7349 131.531 48.0832 133.525C48.3716 135.176 50.0029 136.231 51.6262 135.821L107.656 121.63L107.654 121.628Z",
    fill: "url(#paint0_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6042 125.213H28.7064C24.9836 125.213 21.9623 122.193 21.9623 118.471V40.6814C21.9623 36.9554 24.9836 33.9374 28.7064 33.9374H37.456C37.1741 35.0973 37.0235 36.3091 37.0235 37.5565C37.0235 38.9966 37.2227 40.3915 37.597 41.7134L29.5747 45.2045C28.1345 45.8298 27.4639 47.4935 28.0616 48.9451C28.9413 51.0673 30.2648 54.4903 31.8168 59.1916L29.5018 111.21C29.4727 111.884 30.0008 112.48 30.7589 112.621L44.7784 115.231C45.4523 118.859 46.0712 122.25 46.6042 125.213Z",
    fill: "url(#paint1_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.695 59.8687C121.9 53.0663 113.933 49.2059 105.687 48.4429C97.1692 47.6539 88.3532 50.1682 81.3272 56.1557C67.4957 67.9363 65.8352 88.6966 77.6142 102.523C87.4071 114.022 103.413 117.11 116.478 111.051C117.84 110.421 119.169 109.689 120.455 108.859C121.672 108.075 122.849 107.2 123.982 106.233C125.114 105.271 126.167 104.244 127.134 103.168C137.995 91.1007 138.508 72.563 127.696 59.8671L127.695 59.8687ZM116.878 97.8966C116.457 98.2546 116.029 98.5932 115.59 98.9123C106.406 105.637 93.4497 104.226 85.954 95.4229C78.097 86.1986 79.205 72.3508 88.4293 64.4971C94.5254 59.3066 102.638 58.03 109.706 60.4244C113.335 61.6491 116.689 63.8442 119.353 66.9724C127.21 76.1967 126.102 90.0412 116.878 97.8982V97.8966Z",
    fill: "url(#paint2_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.353 66.9708C111.496 57.7465 97.652 56.64 88.4277 64.4954C79.2034 72.3508 78.097 86.197 85.9523 95.4212C93.8077 104.646 107.654 105.752 116.878 97.8966C126.102 90.0396 127.209 76.1951 119.353 66.9708ZM112.98 89.39L110.845 91.5235C110.134 92.2347 108.982 92.2347 108.271 91.5235L102.653 85.9054L97.0331 91.5235C96.3252 92.2347 95.1718 92.2347 94.4606 91.5235L92.3254 89.39C91.6126 88.6772 91.6126 87.5254 92.3254 86.8142L97.9436 81.1976L92.3254 75.5778C91.6142 74.8667 91.6126 73.7165 92.3254 73.0037L94.4606 70.8685C95.1718 70.1573 96.3236 70.1573 97.0331 70.8685L102.653 76.4883L108.271 70.8685C108.982 70.1573 110.134 70.1573 110.845 70.8685L112.98 73.0037C113.693 73.7165 113.692 74.8667 112.98 75.5778L107.362 81.1976L112.98 86.8142C113.693 87.5254 113.693 88.6772 112.98 89.39Z",
    fill: "url(#paint3_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.133 103.17L132.377 109.327L125.697 115.017L120.453 108.861C121.668 108.077 122.848 107.202 123.98 106.236C125.113 105.271 126.166 104.245 127.131 103.17H127.133Z",
    fill: "url(#paint4_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.578 109.17L125.502 115.197C124.137 116.359 123.973 118.407 125.135 119.771L149.219 148.05C150.381 149.414 152.429 149.578 153.794 148.416L160.871 142.389C162.235 141.227 162.399 139.179 161.237 137.815L137.153 109.536C135.991 108.172 133.943 108.008 132.578 109.17Z",
    fill: "url(#paint5_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.98 89.39L110.845 91.5235C110.134 92.2347 108.982 92.2347 108.271 91.5235L102.653 85.9054L97.0332 91.5235C96.3252 92.2347 95.1718 92.2347 94.4606 91.5235L92.3254 89.39C91.6126 88.6772 91.6126 87.5254 92.3254 86.8142L97.9436 81.1977L92.3254 75.5779C91.6143 74.8667 91.6126 73.7165 92.3254 73.0037L94.4606 70.8685C95.1718 70.1573 96.3236 70.1573 97.0332 70.8685L102.653 76.4883L108.271 70.8685C108.982 70.1573 110.134 70.1573 110.845 70.8685L112.98 73.0037C113.693 73.7165 113.692 74.8667 112.98 75.5779L107.362 81.1977L112.98 86.8142C113.693 87.5254 113.693 88.6772 112.98 89.39Z",
    fill: "url(#paint6_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.773 116.967C116.825 118.325 115.919 119.535 114.602 119.867L107.654 121.628L51.6245 135.819C50.0013 136.231 48.37 135.176 48.0816 133.524C47.7333 131.531 47.2262 128.66 46.6042 125.213C46.0712 122.25 45.4523 118.859 44.7784 115.231C42.4586 102.779 39.4713 87.5318 36.9247 77.1412C35.1459 69.8917 33.3704 63.9009 31.8168 59.1932C30.2648 54.4903 28.9413 51.0673 28.0616 48.9451C27.4639 47.4935 28.1345 45.8298 29.5747 45.2045L37.597 41.7134C39.4065 48.1108 45.2871 52.7974 52.2612 52.7974C54.6539 52.7974 56.9171 52.2466 58.9307 51.2633C64.0046 48.7912 67.5022 43.5829 67.5022 37.5565C67.5022 34.6664 66.697 31.9642 65.299 29.6622L79.508 23.4803C80.224 23.1692 81.0211 23.1676 81.7258 23.4495L82.492 33.9374L83.0007 40.9163C83.1902 43.5181 85.9507 45.1024 88.2949 43.9554L91.7924 42.2447L100.497 37.9841L100.775 38.2028C101.101 38.4572 101.368 38.7779 101.558 39.1424C102.199 40.3834 103.81 43.6315 105.687 48.4445C101.438 48.0508 97.1141 48.4785 92.975 49.7518C92.5798 49.8733 92.1845 50.0029 91.7924 50.1406C88.0664 51.4415 84.5138 53.4422 81.3272 56.1557C67.4957 67.9363 65.8336 88.6966 77.6142 102.523C81.5378 107.132 86.4626 110.39 91.7924 112.248C96.8792 114.024 102.339 114.524 107.654 113.713C110.67 113.251 113.645 112.366 116.476 111.051C116.629 113.62 116.719 115.597 116.773 116.967Z",
    fill: "url(#paint7_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.497 37.9841L88.2949 43.9555C85.9507 45.1024 83.1902 43.5164 83.0007 40.9147L81.7258 23.4479C81.9769 23.5451 82.2134 23.6812 82.4305 23.8513L100.498 37.9841H100.497Z",
    fill: "url(#paint8_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7785 115.231L30.759 112.621C30.0024 112.48 29.4743 111.884 29.5035 111.21L31.8185 59.1932C32.3061 60.6641 32.8115 62.2631 33.3348 63.9868C33.4385 64.3286 33.5421 64.6753 33.6474 65.0268C34.0168 66.2677 34.3942 67.5702 34.7766 68.931C34.8835 69.3182 34.992 69.7118 35.1006 70.1087C35.2123 70.5105 35.3209 70.9155 35.4311 71.3237C35.6498 72.1418 35.8717 72.9761 36.092 73.8315C36.092 73.8331 36.092 73.8347 36.0936 73.8347C36.301 74.6383 36.5083 75.458 36.7173 76.2955C36.7854 76.5758 36.8566 76.8544 36.9247 77.1379C37.1304 77.9771 37.3394 78.847 37.5484 79.7461C37.6505 80.1787 37.7525 80.6161 37.8562 81.0616C38.232 82.6945 38.616 84.4085 38.9999 86.1808C39.0923 86.6084 39.1862 87.041 39.2802 87.4784C39.635 89.1178 39.9881 90.8026 40.3429 92.5133C40.445 93.001 40.5438 93.487 40.6442 93.9794C40.9958 95.6966 41.3489 97.4365 41.6956 99.1829C41.8203 99.8131 41.9467 100.445 42.0714 101.077C42.1379 101.417 42.2043 101.755 42.2723 102.096C42.2885 102.178 42.3031 102.258 42.3193 102.339C42.4619 103.072 42.6044 103.806 42.747 104.537C42.8102 104.851 42.8701 105.169 42.9317 105.483C42.9754 105.708 43.0175 105.932 43.0613 106.154C43.0985 106.348 43.1358 106.541 43.173 106.732C43.2119 106.941 43.254 107.148 43.2929 107.356C43.3334 107.563 43.3739 107.77 43.4128 107.976C43.5294 108.597 43.6493 109.214 43.7643 109.826C43.7854 109.936 43.8048 110.045 43.8275 110.154C43.8761 110.418 43.9279 110.678 43.9765 110.939C44.0219 111.177 44.0673 111.417 44.111 111.655C44.3394 112.864 44.563 114.056 44.7801 115.224L44.7785 115.231Z",
    fill: "url(#paint9_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5021 37.5565C67.5021 43.5829 64.0062 48.7912 58.9307 51.2633C56.9171 52.2483 54.6539 52.7974 52.2628 52.7974C43.8469 52.7974 37.0251 45.9756 37.0251 37.5581C37.0251 33.8483 38.3502 30.4463 40.5567 27.8041C43.3496 24.4523 47.5567 22.3204 52.2628 22.3204C60.6803 22.3204 67.5021 29.1422 67.5021 37.5581V37.5565Z",
    fill: "url(#paint10_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9992 39.0598C57.9992 41.2809 57.5003 42.9932 56.504 44.1969C55.506 45.4005 54.1015 46.0032 52.2871 46.0032C50.4727 46.0032 49.0422 45.3973 48.0427 44.1855C47.0415 42.9738 46.541 41.2647 46.541 39.0598V36.0564C46.541 33.8353 47.0399 32.123 48.0362 30.9193C49.0341 29.7157 50.4435 29.113 52.2644 29.113C54.0853 29.113 55.4963 29.7189 56.4975 30.9307C57.4986 32.1424 57.9992 33.8548 57.9992 36.0677V39.0598ZM54.1938 35.5704C54.1938 34.3894 54.0399 33.5065 53.7305 32.9233C53.4211 32.3401 52.9335 32.0485 52.2628 32.0485C51.5921 32.0485 51.132 32.319 50.834 32.8617C50.5359 33.4044 50.3771 34.2241 50.3544 35.3225V39.5232C50.3544 40.7495 50.5083 41.647 50.8178 42.2156C51.1256 42.7842 51.6148 43.0677 52.2855 43.0677C52.9562 43.0677 53.4114 42.7907 53.7192 42.2383C54.027 41.6859 54.1857 40.8175 54.1938 39.6366V35.572V35.5704Z",
    fill: "#9B9896"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.8596 69.4316C40.6685 69.4316 40.4886 69.3182 40.4109 69.1319C40.3072 68.884 40.4255 68.5989 40.6733 68.4969L77.9042 53.0145C78.152 52.9108 78.4371 53.0291 78.5392 53.277C78.6429 53.5248 78.5246 53.8099 78.2768 53.912L41.0459 69.3943C40.9844 69.4203 40.9212 69.4316 40.8596 69.4316ZM51.158 72.4788C50.9749 72.4788 50.7999 72.3751 50.7173 72.1969C50.6039 71.9539 50.7092 71.664 50.9538 71.5522L66.9449 64.118C67.1879 64.0046 67.4778 64.1099 67.5912 64.3545C67.7046 64.5991 67.5993 64.8875 67.3547 65.0009L51.3637 72.4335C51.2973 72.4642 51.2276 72.4788 51.1596 72.4788H51.158ZM55.809 75.3365C55.6324 75.3365 55.4623 75.2409 55.3764 75.0724C55.2533 74.8343 55.3473 74.5411 55.587 74.418L59.4621 72.427C59.7018 72.3055 59.9934 72.3978 60.1166 72.6376C60.2397 72.8757 60.1457 73.1689 59.906 73.2921L56.0309 75.283C55.9596 75.3203 55.8835 75.3365 55.809 75.3365ZM55.5109 115.812C55.2938 115.812 55.0946 115.665 55.0395 115.444C54.9747 115.184 55.1334 114.92 55.3926 114.855C60.3353 113.622 65.3135 112.242 70.1865 110.756C70.4441 110.678 70.7146 110.823 70.7924 111.079C70.8701 111.335 70.7259 111.607 70.47 111.684C65.5808 113.175 60.5864 114.558 55.6275 115.796C55.5887 115.806 55.5482 115.811 55.5093 115.811L55.5109 115.812ZM57.7708 106.544C57.5748 106.544 57.3901 106.424 57.3156 106.23C57.22 105.979 57.348 105.699 57.5991 105.603C60.2964 104.584 63.0812 103.708 65.8757 102.996C66.1349 102.93 66.4005 103.087 66.467 103.348C66.5334 103.609 66.3762 103.873 66.1154 103.939C63.3566 104.641 60.6058 105.507 57.9425 106.513C57.8858 106.534 57.8275 106.544 57.7708 106.544Z",
    fill: "#B2B5B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.684 123.063L158.196 134.232C157.759 131.22 156.351 128.524 154.297 126.473C152.745 124.921 150.827 123.739 148.682 123.063H148.684Z",
    fill: "url(#paint11_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0547 39.5733H13.7991V39.575C9.98567 39.575 6.53345 38.0295 4.03379 35.5298C1.53413 33.0302 -0.0113525 29.5779 -0.0113525 25.7645C-0.0113525 18.1375 6.17219 11.954 13.7991 11.9491H144.533C148.347 11.9491 151.799 13.4946 154.299 15.9942C156.798 18.4939 158.344 21.9461 158.344 25.7596C158.344 33.3866 152.158 39.5701 144.533 39.5701H129.725C122.853 39.5701 117.154 44.5921 116.094 51.1644C112.781 49.6838 109.261 48.7701 105.687 48.4396C103.811 43.6282 102.201 40.3785 101.559 39.1392C101.368 38.7747 101.103 38.4539 100.777 38.1996L100.5 37.9809L82.4321 23.848C82.2166 23.6779 81.9801 23.5451 81.729 23.4462C81.0227 23.1644 80.2256 23.166 79.5096 23.477L65.3022 29.6589C62.6308 25.2574 57.7919 22.3155 52.2644 22.3155C47.5583 22.3155 43.3512 24.449 40.5567 27.7992C39.0922 29.5536 38.0198 31.6434 37.4609 33.9357H28.7064C25.3595 33.9357 22.5828 36.3755 22.0547 39.5733ZM142.225 94.8089C135.785 94.8089 130.374 99.2186 128.847 105.182V105.18L127.133 103.168C126.953 103.372 126.767 103.572 126.58 103.769C126.765 103.57 126.95 103.371 127.131 103.168C136.043 93.2667 137.987 79.0042 132.42 67.1912H144.532C148.345 67.1912 151.797 68.7366 154.297 71.2363C156.797 73.7343 158.342 77.1882 158.342 81.0017C158.342 88.627 152.157 94.8089 144.532 94.8089H142.225ZM13.7991 94.8089H21.9623V67.1912H13.7991C6.17219 67.1912 -0.0113525 73.3731 -0.0113525 81.0017C-0.0113525 84.8151 1.53413 88.2674 4.03379 90.7638C6.53345 93.2634 9.98567 94.8089 13.7991 94.8089ZM125.226 119.869L149.126 147.927C149.451 148.309 149.844 148.598 150.27 148.797C148.522 149.597 146.581 150.046 144.533 150.046H13.7991C9.98567 150.046 6.53345 148.501 4.03379 146.001C1.53413 143.501 -0.0113525 140.049 -0.0113525 136.235C-0.0113525 128.61 6.17219 122.428 13.8008 122.428H23.2502C24.4749 124.115 26.4627 125.213 28.7064 125.213H30.6666V131.039C30.6666 134.761 33.6863 137.781 37.409 137.781H100.913C104.636 137.781 107.655 134.763 107.655 131.039V121.628L114.605 119.867C115.921 119.535 116.826 118.326 116.773 116.969C116.719 115.597 116.63 113.622 116.478 111.053C117.839 110.422 119.167 109.692 120.453 108.861H120.455L125.697 115.017L125.608 115.093C124.184 116.305 124.013 118.445 125.226 119.869Z",
    fill: "url(#paint12_linear_1784_14238)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.935 52.5236C132.547 52.5236 134.664 50.4065 134.664 47.7948C134.664 45.1832 132.547 43.066 129.935 43.066C127.324 43.066 125.207 45.1832 125.207 47.7948C125.207 50.4065 127.324 52.5236 129.935 52.5236Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.682 142.05C122.841 142.05 124.591 140.3 124.591 138.141C124.591 135.982 122.841 134.232 120.682 134.232C118.523 134.232 116.773 135.982 116.773 138.141C116.773 140.3 118.523 142.05 120.682 142.05Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9697 83.3619C14.6589 83.3619 16.0283 81.9926 16.0283 80.3034C16.0283 78.6142 14.6589 77.2448 12.9697 77.2448C11.2805 77.2448 9.91113 78.6142 9.91113 80.3034C9.91113 81.9926 11.2805 83.3619 12.9697 83.3619Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8728 90.7184C59.9038 90.7184 61.5502 89.072 61.5502 87.041C61.5502 85.01 59.9038 83.3636 57.8728 83.3636C55.8419 83.3636 54.1954 85.01 54.1954 87.041C54.1954 89.072 55.8419 90.7184 57.8728 90.7184Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.362 26.4076C101.236 26.4076 101.945 25.699 101.945 24.8249C101.945 23.9507 101.236 23.2421 100.362 23.2421C99.4881 23.2421 98.7795 23.9507 98.7795 24.8249C98.7795 25.699 99.4881 26.4076 100.362 26.4076Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.308 37.5581C110.83 37.5581 112.063 36.3243 112.063 34.8024C112.063 33.2805 110.83 32.0468 109.308 32.0468C107.786 32.0468 106.552 33.2805 106.552 34.8024C106.552 36.3243 107.786 37.5581 109.308 37.5581Z",
    fill: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4989 141.199C15.3435 141.199 16.0282 140.515 16.0282 139.67C16.0282 138.825 15.3435 138.141 14.4989 138.141C13.6543 138.141 12.9697 138.825 12.9697 139.67C12.9697 140.515 13.6543 141.199 14.4989 141.199Z",
    fill: "#C5C4C3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1784_14238",
    x1: 68.9861,
    y1: 131.667,
    x2: 69.9792,
    y2: 111.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A19F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1784_14238",
    x1: 9.53046,
    y1: 84.564,
    x2: 63.9625,
    y2: 74.8035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1784_14238",
    x1: 97.2194,
    y1: 75.4207,
    x2: 142.635,
    y2: 123.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A19F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1784_14238",
    x1: 99.5749,
    y1: 78.2832,
    x2: 136.428,
    y2: 113.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2D6",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD2D6",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1784_14238",
    x1: 127.684,
    y1: 110.933,
    x2: 125.119,
    y2: 107.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1784_14238",
    x1: 133.918,
    y1: 119.063,
    x2: 165.062,
    y2: 151.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A19F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1784_14238",
    x1: 101.624,
    y1: 74.5169,
    x2: 102.085,
    y2: 97.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A19F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1784_14238",
    x1: 56.4424,
    y1: 67.5556,
    x2: 124.44,
    y2: 138.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1784_14238",
    x1: 91.0694,
    y1: 36.4274,
    x2: 97.4389,
    y2: 12.6119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A19F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1784_14238",
    x1: 37.1065,
    y1: 94.0171,
    x2: 71.0706,
    y2: 55.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A19F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1784_14238",
    x1: 50.0693,
    y1: 27.736,
    x2: 55.5287,
    y2: 52.1802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1784_14238",
    x1: 153.44,
    y1: 42.8879,
    x2: 153.44,
    y2: 151.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2D6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD2D6",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1784_14238",
    x1: 75.1291,
    y1: 42.8878,
    x2: 75.1291,
    y2: 151.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1784_14238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1784_14238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.7d4b812b1e0794037d2650243022eea0.svg";
export { ForwardRef as ReactComponent };